export default function FeatureGrid() {
  return (
    <section id="features" className="bg-background-100 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            Why AllChinaBuySpreadsheet?
          </h2>
          <p className="text-foreground-600 text-base max-w-lg">
            A purpose-built sourcing intelligence system, not just another spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Card 1: Real-Time Tracking */}
          <div className="bg-foreground-950 rounded-2xl p-8 group cursor-pointer transition-all duration-300 hover:scale-[1.02]">
            <div className="w-12 h-12 rounded-full bg-foreground-700/40 flex items-center justify-center mb-6">
              <span className="text-white text-sm font-semibold">01</span>
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-4">
              Real-Time Tracking
            </h3>
            <p className="text-foreground-400 text-sm leading-relaxed">
              Daily updated product data so you never work with outdated information. Prices, stock, and trends refresh automatically.
            </p>
          </div>

          {/* Card 2: Viral Detection */}
          <div className="bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden group cursor-pointer transition-all duration-300 hover:scale-[1.02]">
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20flat%20lay%20of%20trendy%20fashion%20accessories%20and%20sunglasses%20on%20warm%20cream%20surface%2C%20soft%20golden%20hour%20lighting%2C%20editorial%20style%2C%20neutral%20warm%20tones%2C%20aesthetic%20composition%2C%20no%20text&width=800&height=600&seq=feat-viral-2026b&orientation=landscape"
                alt="Viral Detection"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="px-3 py-1 bg-foreground-950/70 backdrop-blur-sm text-white text-xs font-medium rounded-full">
                  Trending
                </span>
              </div>
            </div>
            <div className="p-6">
              <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-2">
                Viral Detection
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                AI-powered trend analysis identifies products gaining momentum before they reach peak saturation.
              </p>
            </div>
          </div>

          {/* Card 3: Supplier Database */}
          <div className="bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden group cursor-pointer transition-all duration-300 hover:scale-[1.02]">
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20photography%20of%20organized%20product%20catalog%20cards%20and%20fabric%20samples%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20beige%20tones%2C%20aesthetic%2C%20no%20text&width=800&height=600&seq=feat-supplier-2026b&orientation=landscape"
                alt="Supplier Database"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-6">
              <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-2">
                Supplier Database
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                Compare verified Chinese suppliers side by side. Ratings, shipping timelines, and MOQ all in one view.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}